import * as React from "react";
import { selectBalancingFarmEventCharacterProfilePictureByEventType, selectBalancingFarmEventDisplayInfoByEventType, } from "../../balancingSelectors/selectBalancingFarmEvents";
import { IdDefaultThreshold } from "../../constants/IdDefaultThreshold";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { TextLoca } from "../generic/text/TextLoca";
import { ProfilePicture } from "../player-profile/ProfilePicture";
import { EventPrizes } from "./EventPrizes";
export var EventThresholdDescription = function (_a) {
    var eventType = _a.eventType, eventCompleted = _a.eventCompleted;
    var balancingInfos = selectBalancingFarmEventDisplayInfoByEventType(eventType);
    var character = selectBalancingFarmEventCharacterProfilePictureByEventType(eventType);
    if (balancingInfos == undefined || character == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var _b = getEventDescription(eventType, eventCompleted), title = _b.title, description = _b.description, replacements = _b.replacements;
    return (React.createElement("div", { className: "tournament-info__details" },
        React.createElement(ProfilePicture, { profilePictureName: character, profilePictureClassName: "profile_image", profilePictureSize: IdStyles.ProfilePictureLarge }),
        React.createElement("div", { className: "tournament-info__details-text " + IdStyles.TournamentDetailsContainer },
            React.createElement(TextLoca, { className: IdStyles.TextButtonHeading, id: title }),
            React.createElement("div", null,
                React.createElement(TextLoca, { className: IdStyles.TextNormal, id: description, replacements: replacements }))),
        React.createElement("div", { className: "flex " + IdStyles.TournamentTopPrizes },
            React.createElement(EventPrizes, null))));
};
var getEventDescription = function (eventId, eventCompleted) {
    var isCollectLeague = eventId !== EventType.CoopLeague && eventId !== EventType.PlayerLeague;
    if (isCollectLeague) {
        return getCollectLeagueInfos(eventId, eventCompleted);
    }
    return getGenericLeagueInfos(eventId);
};
var getCollectLeagueInfos = function (eventId, eventCompleted) {
    var displayInfo = selectBalancingFarmEventDisplayInfoByEventType(eventId);
    var locaKeyDescription = displayInfo.locaKeyDescription, locaKeyTitle = displayInfo.locaKeyTitle, locaKeyComplete = displayInfo.locaKeyComplete;
    return {
        description: eventCompleted ? locaKeyComplete : locaKeyDescription,
        title: locaKeyTitle,
    };
};
var getGenericLeagueInfos = function (eventId) {
    var displayInfo = selectBalancingFarmEventDisplayInfoByEventType(eventId);
    var locaKeyDescription = displayInfo.locaKeyDescription, locaKeyTitle = displayInfo.locaKeyTitle;
    var replacements = getLeagueReplacements(eventId);
    return {
        description: locaKeyDescription,
        replacements: replacements,
        title: locaKeyTitle,
    };
};
var getLeagueReplacements = function (eventId) {
    var isCoopLeague = eventId === EventType.CoopLeague;
    var defaultTreshold = !isCoopLeague
        ? IdDefaultThreshold.PlayerLeagueCompetitionThreshold
        : IdDefaultThreshold.CoopLeagueCompetitionThreshold;
    return new Map([[ReplacementLoca.zero_0, defaultTreshold.toString()]]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventThresholdDescription.tsx
// module id = 2772
// module chunks = 3